export default __webpack_public_path__ + "static/media/science.27bc095b.svg";